import styled, {css} from 'styled-components';


export const ContainerWrapper = styled.div`
  display: flex;
  padding: 0px 16px;

  @media screen and (max-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    padding: 5px 16px;
  } 
`;

export const Container = styled.div<{backgroundColor: string}>`
  display: flex;
  flex: 1;
  
  background-color: ${props=>handleBackgroundColor(props.backgroundColor)};

  @media screen and (max-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    flex-direction: column;
    
  } 
`;

export const StyledColumn = styled.div<{colCount: number, backgroundColor: string}>`
  flex: 1;
  
  padding: 52px 40px 44px 40px;
  ${props=>props.colCount === 1 && css`
    max-width: 824px;
  `}

  @media screen and (max-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
    padding: 24px 0px;
    ${props=>props.backgroundColor !== 'default' && css`
      padding: 15px 20px;
    `}
  } 
`;

const handleBackgroundColor = (color: string) => {
  switch (color.toLowerCase()) {
    case 'secondary':
      return 'rgba(59, 59, 59, 0.15)';
    case 'custom':
    case 'default':
    default:
      return '';
  }
};